<template>
    <div class="result-pie line">
        <Echart :initOptions="initOptions" :options="options"></Echart>
        <div class="category" v-if="Array.isArray(category) && category.length">
            <div
                class="category-item"
                v-for="item in category"
                :key="item.name"
            >
                <div
                    class="mark"
                    :style="{ backgroundColor: item.color }"
                ></div>
                <span class="category-title" :style="{ color: item.color }">{{
                    item.name
                }}</span>
            </div>
        </div>
    </div>
</template>

<script>
import { numberFormat } from '../../../common/format';
import Echart from '../../../components/echart.vue';
export default {
    i18next: {
        ns: 'md-calculator'
    },
    components: { Echart },
    data: function() {
        return {
            initOptions: null,
            options: null,
            category: []
        };
    },
    computed: {
        isMobileSize() {
            return this.platform.isMobile;
        }
    },
    methods: {
        refresh(data) {
            let count = data[0].length;
            data[2][data[2].length - 1] = 0;

            let interval = 0;
            if (count >= 360) {
                interval = 99;
            }
            if (count < 360 && count >= 180) {
                interval = 49;
            }
            if (count < 180) {
                interval = 24;
            }
            let context = this;
            let lineOptions = {
                grid: {
                    left: 60,
                    right: 10,
                    top: 20,
                    bottom: 20
                },
                yAxis: {
                    type: 'value',
                    splitNumber: 5,
                    axisLine: {
                        show: false
                    },
                    axisTick: {
                        show: false
                    },
                    axisLabel: {
                        inside: false,
                        margin: 14,
                        showMinLabel: false,
                        verticalAlign: 'middle',
                        align: 'right',
                        padding: [10, 0, 0, 0],
                        fontStyle: {
                            color: '#a8a8a8',
                            fontSize: 12
                        }
                    },
                    splitLine: {
                        lineStyle: {
                            color: 'rgba(0, 0, 0, 0.1)',
                            type: 'dashed'
                        }
                    }
                },
                xAxis: {
                    type: 'category',
                    data: [
                        ...data[0].map((item, index) => index),
                        data[0].length + 1,
                        data[0].length + 2,
                        data[0].length + 3
                    ],
                    boundaryGap: false,
                    axisLine: {
                        lineStyle: {
                            // color: 'rgba(0,0,0,0.1)'
                        }
                    },
                    axisTick: {
                        interval: interval,
                        lineStyle: {
                            color: 'rgba(0,0,0,0.1)'
                        }
                    },
                    axisLabel: {
                        fontStyle: {
                            color: '#a8a8a8',
                            fontSize: 12
                        },
                        interval: interval
                    }
                },
                tooltip: {
                    trigger: 'axis',
                    position: 'right',
                    backgroundColor: 'rgba(255,255,255,0.9)',
                    borderWidth: 1,
                    borderColor: '#e0e0e0',
                    extraCssText:
                        'box-shadow: 1px 1px 4px 1px rgba(0, 0, 0, 0.3); z-index:var(--level-sublow);',
                    formatter: function(params) {
                        return `<span style="display:inline-block;color:rgb(0,158,66);width:100px">${context.$t(
                            'common:caculator.interest'
                        )}:</span>
                            <span style="color:black">$${numberFormat(
                            params[0].value
                        )}</span>
                            <br/>
                            <span style="display:inline-block;color:rgb(24,159,299);width:100px">${context.$t(
                            'common:caculator.principle'
                        )}:</span>
                            <span style="color:black">$${numberFormat(
                            params[1].value
                        )}</span>
                            <br/>
                            <span style="display:inline-block;color:rgb(255,185,1);width:100px">${context.$t(
                            'common:caculator.remaining'
                        )}:</span>
                            <span style="color:black">$${numberFormat(
                            params[2].value
                        )}</span>
                            <br/>
                            <div style="color:#787878;text-align:right">${
                                params[0].axisValue
                            }mo</div>
                            `;
                    }
                },
                series: [
                    //interest
                    {
                        data: data[0],
                        type: 'line',
                        hoverAnimation: false,
                        symbol: 'circle',
                        symbolSize: 10,
                        showSymbol: false,
                        lineStyle: {
                            color: 'rgb(0,158,66)'
                        },
                        itemStyle: {
                            color: 'rgb(0,158,66)'
                        }
                    },
                    //Principal
                    {
                        data: data[1],
                        hoverAnimation: false,
                        symbol: 'diamond',
                        symbolSize: 10,
                        showSymbol: false,
                        type: 'line',
                        lineStyle: {
                            color: 'rgb(24,159,299)'
                        },
                        itemStyle: {
                            color: 'rgb(24,159,299)'
                        }
                    },
                    //remaining
                    {
                        data: data[2],
                        type: 'line',
                        hoverAnimation: false,
                        symbol: 'rect',
                        symbolSize: 10,
                        showSymbol: false,
                        lineStyle: {
                            color: 'rgb(255,185,1)'
                        },
                        itemStyle: {
                            color: 'rgb(255,185,1)'
                        }
                    }
                ]
            };

            this.category = [
                {
                    name: this.$t('md-calculator.remaining'),
                    color: 'rgb(255,185,1)'
                },
                {
                    name: this.$t('md-calculator.interest'),
                    color: 'rgb(0,158,66)'
                },
                {
                    name: this.$t('md-calculator.principle'),
                    color: 'rgb(24,159,299)'
                }
            ];
            this.options = lineOptions;
        }
    }
};
</script>
<style lang="scss">
@import '../../../theme/media.scss';
@import '../../../theme/mixin.scss';
.result-pie.line {
    .category {
        margin-top: 50px;
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: center;
        gap: 30px;
        @include media-600 {
            margin-top: 15px;
        }
        .category-item {
            flex-shrink: 0;
            position: relative;
            padding-left: 20px;
            .mark {
                position: absolute;
                width: 6px;
                height: 6px;
                border-radius: 50%;
                left: 0;
                top: 50%;
                transform: translateY(-50%);
            }
            .category-title {
                font-size: 12px;
            }
        }
    }
}
</style>
